import "core-js/modules/es.array.includes.js";
import ProTreeIcon from "@/components/login-unit/pro-tree-icon.vue";
export default {
  name: "ProTreeNode",
  components: {
    ProTreeIcon
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      default: 0
    },
    favoriteUnitIds: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      typeList: {
        ALLIANCE: {
          icon: "public",
          label: $t("mhaj2", "联盟")
        },
        GC: {
          icon: "apartment",
          label: $t("1pbp04", "GC单位")
        },
        GROUP: {
          icon: "domain",
          label: $t("iqfa5d4", "酒店集团")
        },
        CHAIN: {
          icon: "hub",
          label: $t("q1dy2", "链组")
        },
        HOTEL: {
          icon: "hotel",
          label: $t("p8jp2", "酒店")
        },
        SCENIC_AREA: {
          icon: "park",
          label: $t("hvor2", "景区")
        },
        SCENIC_SPOT: {
          icon: "landscape",
          label: $t("i1ii2", "景点")
        },
        CATERING_CHAIN_LIKE: {
          icon: "restaurant",
          label: $t("jy69j54", "餐饮连锁")
        },
        CATERING: {
          icon: "storefront",
          label: $t("p6vw5u6", "餐饮/零售店")
        },
        MANAGE: {
          icon: "corporate_fare",
          label: $t("g2qrf54", "管理公司")
        }
      }
    };
  },
  computed: {
    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    },
    materialIconName() {
      const typeInfo = this.typeList[this.node.type];
      return typeInfo ? typeInfo.icon : "business";
    },
    typeLabel() {
      const typeInfo = this.typeList[this.node.type];
      // 单位类型可能为空或后端返回未知枚举，统一用“其他”兜底，避免界面出现无意义的横杠。
      return typeInfo ? typeInfo.label : $t("eae82", "其他");
    },
    iconClass() {
      if (this.depth === 0) return "node-icon-enterprise";
      if (this.depth === 1) return "node-icon-chain";
      return "node-icon-property";
    },
    iconStyle() {
      if (this.depth === 0) return {
        fontSize: "18px"
      };
      if (this.depth === 1) return {
        fontSize: "15px"
      };
      return {
        fontSize: "16px"
      };
    },
    typeTagClass() {
      if (this.depth === 0) return "type-tag-enterprise";
      if (this.depth === 1) return "type-tag-chain";
      return "type-tag-property";
    },
    isFavoriteUnit() {
      return !!this.node.unitId && this.favoriteUnitIds.includes(this.node.unitId);
    }
  },
  methods: {
    toggle() {
      if (this.hasChildren) {
        this.node.expand = !this.node.expand;
      }
    },
    toggleFavorite() {
      this.$emit("toggle-favorite", this.node);
    },
    beforeEnter(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    },
    enter(el, done) {
      const childCount = el.children.length;
      const itemHeight = el.firstChild ? el.firstChild.clientHeight : 0;
      const totalHeight = childCount * itemHeight;
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      el.style.overflow = "hidden";
      setTimeout(() => {
        el.style.height = totalHeight + "px";
        el.style.opacity = "1";
      }, 10);
      const onTransitionEnd = () => {
        el.removeEventListener("transitionend", onTransitionEnd);
        done();
      };
      el.addEventListener("transitionend", onTransitionEnd);
    },
    afterEnter(el) {
      el.style.height = "";
      el.style.opacity = "";
      el.style.overflow = "";
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
      el.style.overflow = "hidden";
    },
    leave(el, done) {
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      setTimeout(() => {
        el.style.height = "0";
        el.style.opacity = "0";
      }, 10);
      const onTransitionEnd = () => {
        el.removeEventListener("transitionend", onTransitionEnd);
        done();
      };
      el.addEventListener("transitionend", onTransitionEnd);
    },
    afterLeave(el) {
      el.style.height = "";
      el.style.opacity = "";
      el.style.overflow = "";
    },
    onChange() {
      this.$emit("on-change", this.node);
    }
  }
};